import { styled } from '@mui/material'

export const HeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(43, 49, 58, 1);
  height: 40px;
`
export const HeaderRight = styled('div')`
  display: flex;
  gap: 4px;
`

export const HeaderLeft = styled('div')`
  display: flex;
  gap: 4px;
`

export const IntervalBox = styled('div')`
  display: flex;
  align-items: center;
`

export const InterveItemrBox = styled('div')`
  font-size: 14px;
  color: rgba(149, 164, 173, 1);
  border-radius: 4px;
  padding-inline: 8px;
  display: flex;
  height: 20px;
  align-items: center;
  justify-content: center;
  margin-right: 4px;

  cursor: pointer;
  &:hover {
    background-color: rgba(43, 47, 57, 1);
  }
  &.active {
    color: rgba(160, 238, 9, 1);
    background-color: rgba(58, 80, 25, 1);
  }
`

export const ChartTypeContainer = styled('div')`
  display: flex;
  position: relative;
`

export const CurrentChartType = styled('div')`
  color: rgba(149, 164, 173, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4x;
  border-radius: 4px;
  gap: 4px;

  &:hover {
    background-color: rgba(43, 47, 57, 1);
  }
  cursor: pointer;
`

export const ChartTypeMenu = styled('div')`
  display: flex;
  flex-direction: column;
  top: 0;
  position: absolute;
  z-index: 2;
  border-radius: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  top: 100%;
  left: 0px;
  display: block;
  width: 153px;
  background-color: rgba(30, 35, 41, 1);
  cursor: pointer;
`
export const ChartTypeItem = styled('div')`
  display: flex;
  height: 32px;
  gap: 4px;
  font-size: 12px;
  cursor: pointer;
  color: #fff;
  align-items: center;
  padding-left: 12px;
  padding-right: 24px;
  &:hover {
    background-color: rgba(55, 60, 69, 1);
  }
  &.active {
    color: rgba(160, 238, 9, 1);
    background-color: rgba(58, 80, 25, 1);
  }
`

export const StyledIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(149, 164, 173, 1);
  padding: 4px;
  border-radius: 4px;
  gap: 4px;
  font-size: 14px;

  box-sizing: border-box;

  &:hover {
    background-color: rgba(55, 60, 69, 1);
  }
`

export const StyledRightIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(149, 164, 173, 1);
  padding: 4px;
  border-radius: 4px;
  gap: 4px;
  font-size: 14px;
  width: 28px;
  height: 28px;
  box-sizing: border-box;

  &:hover {
    background-color: rgba(55, 60, 69, 1);
  }
`
